export default {"src":"/_next/static/media/HomeSam.1a99db16.svg","height":48,"width":88};